import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const PartialDerivative = () => (
  <QPhototModuleSubtopic
    title="partial derivative"
    videos={[
      "https://www.youtube.com/embed/eTp5wq-cSXY",
      "https://www.youtube.com/embed/bTs7ncA_AtY",
      "https://www.youtube.com/embed/kmsmhnlJ5UI"
    ]}
    takeaways={[]}
    questions={[
        {
            image:"/cal_19.jpeg"
        },
        {
            image:"/cal_20.jpeg"
        },
        {
            image:"/cal_21.jpeg"
        },
        {
            image:"/cal_22.jpeg"
        }
    ]}
    exampleVideos={[]}
  />
);

export default PartialDerivative;
